@for (block of blocksFiltered(); track identify($index, block)) {
  <div #block>
    @switch (block.type) {
      @case (BlockType.button) {
        <pot-block-button class="container-sm" [id]="block.id" [data]="block.data" />
      }
      @case (BlockType.cardsList) {
        <pot-block-cards-list-container
          class="container-sm"
          [cards]="block.data"
          [cardsAlignedOnSameRow]="block.cardsAlignedOnSameRow ?? false"
          [numberCardsPerRow]="block.numberCardsPerRow"
        />
      }
      @case (BlockType.cardsCarousel) {
        <pot-block-cards-carousel class="container-sm" [cards]="block.data" [aosAnimation]="block.aosAnimation!" />
      }
      @case (BlockType.paragraphs) {
        <pot-block-paragraph class="container-sm" [data]="block.data" />
      }
      @case (BlockType.paragraphsCarousel) {
        <pot-block-paragraph-carousel [data]="block.data" />
      }
      @case (BlockType.image) {
        <pot-block-image class="container-sm" [data]="block.data" />
      }
      @case (BlockType.lottie) {
        <pot-block-lottie class="container-sm" [data]="block.data" />
      }
      @case (BlockType.imageGrid) {
        <pot-block-image-grid [data]="block.data" />
      }
      @case (BlockType.contactUs) {
        <pot-block-contact-us class="container-sm" [data]="block.data" />
      }
    }
  </div>
}
